import React from 'react';

import './Footer.css';

function Footer(props) {
    return(
        <div className="ghost-footer">
	    <div className="ghost-footer-inner">
	    	<div className="ghost-footer-link">Telegram</div>
	    	<div className="ghost-footer-link">Matrix</div>
	    	<div className="ghost-footer-link">Proton</div>
	    	<div className="ghost-footer-link">XMPP</div>
	    </div>
	</div>
    );
}

export default Footer;
